<!-- 互动卡片右侧面板 -->
<template>
  <div class="serviceliststyle">
    <el-form
      label-width="90px"
      :model="datas"
      size="small"
      class="lef"
      style="margin-top: 20px"
    >
      <!-- 标题大小 -->
      <el-form-item
        label="活动："
        prop="wordSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select
              v-model="datas.optionsValue"
              placeholder="请选择活动名称"
            >
              <el-option
                v-for="item in datas.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 背景颜色 -->
      <el-form-item class="lef" label="背景：">
        <div class="weiz">
          <div class="ml35">
            <!-- 背景颜色子组件 -->
            <LinkInput :datas="datas" field="backgroundColor" type="color" />
          </div>
        </div>
      </el-form-item>
      <el-form-item class="lef flexColumn" label="模块样式">
        <div class="weiz">
          <div class="weiz-container" style="">
            <!--   @click="clickChange(item, index)" -->
            <!-- 模块样式1 -->
            <div
              v-for="(item, index) in moduleStyleList"
              :key="index"
              @click="clickChange(item, index)"
              class="preview-item"
              :class="{ active: moduleType == item.commodityType }"
            >
              <InteractionCardPanel
                :datas="item"
                :imagePath="item.src"
              ></InteractionCardPanel>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <!-- 上传图片 -->
    <image-select-modal
      ref="imageSelectModal"
      :isImageLib="false"
      :activeTab="'myFiles'"
      :visible.sync="showImageModal"
      @select="handleImageSelect"
    />
  </div>
</template>

<script>
export default {
  name: "interactioncardstyle",
  props: {
    datas: Object,
  },
  data() {
    return {
      wordSizeOptions: [],
      moduleType: 1, //默认选中的模块样式
      // 构造模块样式列表
      moduleStyleList: [
        { ...this.datas, src: this.$imagePath.image11, moduleType: 1 },
        {
          ...this.datas,
          src: this.$imagePath.image13,
          moduleType: 2,
        },
        {
          ...this.datas,
          src: this.$imagePath.image14,
          moduleType: 3,
        },
      ],
      // 拖拽配置
      dragOptions: {
        animation: 200,
      },
      showImageModal: false, //显示上传图片弹窗
      currentItemIndex: {}, //当前点击的图片项
    };
  },
  created() {},
  methods: {
    //模块样式选择回调
    clickChange(item, index) {
      this.moduleType = item.moduleType;
      this.datas.moduleType = item.moduleType;
      console.log("点击了", item, index, this.datas);
    },
    // 上传图片点击事件
    handleUploadImage(item, index) {
      this.showImageModal = true;
      this.currentItemIndex = index;
      console.log("handleUploadImage方法回调", item, index, this.datas);
    },
    // 上传图片确定回调函数
    handleImageSelect(res) {
      this.datas.imageList[this.currentItemIndex].src = res.url;
      console.log(
        "image-select-modal确定函数回调方法",
        res,
        this.datas,
        this.currentItemIndex,
      );
    },
  },
};
</script>

<style scoped lang="scss">
.serviceliststyle {
  padding: 10px;
}

.lef {
  margin-bottom: 20px;
}

.weiz {
  display: flex;
  align-items: center;
}

.ml35 {
  margin-left: 35px;
  flex: 1;
}
</style>
